/**
 * Route Constants
 *
 * Centralized location for all application route paths.
 * Use these constants throughout the app to ensure consistency and avoid typos.
 */

// ==================== PUBLIC ROUTES ====================
export const ROUTES = {
  // Landing & Explore
  HOME: "/",
  EXPLORE: "/explore",
  LOGIN: "/login",

  // Mall Hub
  MALL_HUB: "/mall/:mallId",

  // Offers
  OFFERS: "/mall/:mallId/offers",
  OFFER_DETAILS: "/mall/:mallId/offers/:offerId",

  // Stores
  STORES: "/mall/:mallId/stores",
  STORE_DETAILS: "/stores/:storeId",

  // Events
  EVENTS: "/mall/:mallId/events",
  EVENT_DETAILS: "/events/:eventId",

  // ==================== PROTECTED ROUTES ====================
  APP: "/app/*",
  APP_ROOT: "/app/",
  APP_DASHBOARD: "/app/dashboard",
  APP_ANALYTICS: "/app/analytics",
  APP_MESSAGES: "/app/messages",
  APP_PAYMENTS: "/app/payments",
} as const;

/**
 * Helper function to generate mall-specific routes
 *
 * @example
 * getMallRoute.offers("phoenix-palladium") // "/mall/phoenix-palladium/offers"
 */
export const getMallRoute = {
  hub: (mallId: string) => `/mall/${mallId}`,
  offers: (mallId: string) => `/mall/${mallId}/offers`,
  stores: (mallId: string) => `/mall/${mallId}/stores`,
  events: (mallId: string) => `/mall/${mallId}/events`,
  offerDetails: (mallId: string, offerId: string) =>
    `/mall/${mallId}/offers/${offerId}`,
};

/**
 * Helper function to generate store/event detail routes
 */
export const getDetailRoute = {
  store: (storeId: string) => `/stores/${storeId}`,
  event: (eventId: string) => `/events/${eventId}`,
};
